module.exports = __webpack_public_path__ + "img/11087941_L.327b2946.png";